export const fetchOptions: globalThis.RequestInit = {
    method: "GET",
    headers: {
        "Content-Type": "application/json",
    },
    credentials: "include",
};

export const apiUrl = "";

export const getApiBasePath = () => (window.location.pathname.startsWith("/demo") ? "/api/demo" : "/api");
